import { render, staticRenderFns } from "./StudentQuizFinishWrapper.vue?vue&type=template&id=14763e5d"
import script from "./StudentQuizFinishWrapper.vue?vue&type=script&lang=js"
export * from "./StudentQuizFinishWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports